import { FormValuesProps } from '../interfaces/form'
import dot from 'dot-object'
import occupations from '../data/occupations.json'
// import moment from 'moment'

const isEmpty = (fieldName: string, values: FormValuesProps) =>
  !dot.pick(fieldName, values)

// const isValidDate = (day: string, month: string, year: string) =>
//   moment(`${year}-${month}-${day}`, 'YYYY-MM-DD').isValid()

const isInAutocompleteData = (
  fieldName: string,
  values: FormValuesProps,
  data: any[]
) => data.find((item) => item === dot.pick(fieldName, values))

const validateField = (
  fieldName: string,
  errorMessage: string,
  customValidator: boolean = false
) => {
  const errors: Record<any, string> = {}

  if (customValidator) {
    errors[fieldName] = errorMessage
  }

  return dot.object(errors)
}

export const validateHouseHold = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'household',
      'This field is required',
      isEmpty('household', values)
    )
  )
}

export const validatePersonalDetails = (values: FormValuesProps) => {
  const age = dot.pick('age', values)

  return Object.assign(
    {},
    validateField('age', 'This field is required', isNaN(age)),
    validateField(
      'age',
      'You must be between 20 and 80 years old.',
      parseInt(age) < 18 || parseInt(age) > 80
    )
  )
}

export const validatePartnerPersonalDetails = (values: FormValuesProps) => {
  const age = dot.pick('partnerAge', values)

  return Object.assign(
    {},
    validateField('partnerAge', 'This field is required', isNaN(age)),
    validateField(
      'partnerAge',
      'You must be between 20 and 80 years old.',
      parseInt(age) < 18 || parseInt(age) > 80
    )
  )
}

export const validateSmoker = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'isSmoker',
      'This field is required',
      dot.pick('isSmoker', values) === null
    )
  )
}

export const validatePartnerSmoker = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'partnerSmoker',
      'This field is required',
      dot.pick('partnerSmoker', values) === null
    )
  )
}

export const validatePartnerCoverage = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'isPartnerCovered',
      'This field is required',
      dot.pick('isPartnerCovered', values) === null
    )
  )
}

export const validateEmploymentStatus = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'employment',
      'This field is required',
      isEmpty('employment', values)
    )
  )
}

export const validatePartnerEmploymentStatus = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'partnerEmployment',
      'This field is required',
      isEmpty('partnerEmployment', values)
    )
  )
}

export const validateIncome = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField('income', 'This field is required', isEmpty('income', values))
  )
}

export const validatePartnerIncome = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'partnerIncome',
      'This field is required',
      isEmpty('partnerIncome', values)
    )
  )
}

export const validateOccupation = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'occupation',
      'This field is required',
      isEmpty('occupation', values)
    ),
    validateField(
      'occupation',
      'Invalid value',
      !isInAutocompleteData('occupation', values, occupations)
    )
  )
}

export const validatePartnerOccupation = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'partnerOccupation',
      'This field is required',
      isEmpty('partnerOccupation', values)
    ),
    validateField(
      'partnerOccupation',
      'Invalid value',
      !isInAutocompleteData('partnerOccupation', values, occupations)
    )
  )
}

export const validatePostcode = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'postcode',
      'This field is required',
      isEmpty('postcode', values)
    )
  )
}

export const validateLivingStatus = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'livingStatus',
      'This field is required',
      isEmpty('livingStatus', values)
    )
  )
}

export const validateLoans = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField('loans', 'This field is required', isEmpty('loans', values))
  )
}

export const validateMonthlyExpenses = (values: FormValuesProps) => {
  return {}
}

export const validateEmergencyFunds = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'emergencyFunds',
      'This field is required',
      isEmpty('emergencyFunds', values)
    )
  )
}

export const validateSickPay = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'sickPayWeeks',
      'This field is required',
      isEmpty('sickPayWeeks', values)
    ),
    validateField(
      'sickPayWeeks',
      'Cannot be greater than 13',
      parseInt(dot.pick('sickPayWeeks', values)) > 26
    )
  )
}

export const validateEmployeeBenefits = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'employeeBenefits',
      'This field is required',
      (values as any)['employeeBenefits']?.length === 0
    )
  )
}

export const validatePolicies = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'policies',
      'This field is required',
      (values as any)['policies']?.length === 0
    )
  )
}

export const validateAppointment = (values: FormValuesProps) => {
  return Object.assign(
    {},
    validateField(
      'appointmentDate',
      'This field is required',
      isEmpty('appointmentDate', values)
    ),
    validateField(
      'appointmentTime',
      'This field is required',
      isEmpty('appointmentTime', values)
    ),
    validateField(
      'appointmentTimeOfDay',
      'This field is required',
      isEmpty('appointmentTimeOfDay', values)
    ),
    validateField('email', 'This field is required', isEmpty('email', values)),
    validateField(
      'firstName',
      'This field is required',
      isEmpty('firstName', values)
    ),
    validateField(
      'lastName',
      'This field is required',
      isEmpty('lastName', values)
    ),
    validateField(
      'isMeeting',
      'This field is required',
      isEmpty('isMeeting', values)
    ),
    validateField(
      'isTelephoneCall',
      'This field is required',
      isEmpty('isTelephoneCall', values)
    ),
    validateField(
      'isVideoCall',
      'This field is required',
      isEmpty('isVideoCall', values)
    )
  )
}
